var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "fill-height",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "rounded": "",
      "flat": "",
      "color": "white"
    }
  }, [_c('v-card-text', {
    ref: "list",
    staticClass: "fill-height",
    staticStyle: {
      "overflow-y": "auto"
    }
  }, [_c('v-row', {
    staticClass: "ma-n4"
  }, [_vm._l(_vm.messages, function (message, index) {
    return [_c('messages-item', _vm._g(_vm._b({
      key: index
    }, 'messages-item', {
      index,
      message,
      isScrollFixed: _vm.isScrollFixed
    }, false), {
      scroll: _vm.scroll
    }))];
  })], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }